var map = {
	"./Rugby.jpg": "ebd6",
	"./badminton.jpg": "6505",
	"./baseball.jpg": "48971",
	"./basketball.jpg": "a9f9",
	"./billiard.jpg": "6ef8",
	"./champion.jpg": "ea16",
	"./hockey.jpg": "e1d6",
	"./pcgame.jpg": "2126",
	"./pingpong.jpg": "5799",
	"./soccer.jpg": "57af",
	"./tennis.jpg": "f498",
	"./volleyball.jpg": "7f56",
	"./worldCup.jpg": "18d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d0fe";